var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect2, _path16, _rect3, _path17, _g, _g2, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransport03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.787109,
    y: 0.53125,
    width: 350,
    height: 233,
    fill: "#D57070"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.949 147.078C215.949 143.764 218.636 141.078 221.949 141.078H227.299C230.613 141.078 233.299 143.764 233.299 147.078V155.179C233.299 158.493 230.613 161.179 227.299 161.179H221.949C218.636 161.179 215.949 158.493 215.949 155.179V147.078Z",
    fill: "#200909"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M293.318 147.078C293.318 143.764 296.005 141.078 299.318 141.078H304.668C307.982 141.078 310.668 143.764 310.668 147.078V155.179C310.668 158.493 307.982 161.179 304.668 161.179H299.318C296.005 161.179 293.318 158.493 293.318 155.179V147.078Z",
    fill: "#200909"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M253.874 79.5848C254.062 78.6516 254.882 77.9805 255.834 77.9805H271.249C272.201 77.9805 273.021 78.6516 273.21 79.5848L274.603 86.4892H252.48L253.874 79.5848Z",
    fill: "#FFC7C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225.27 90.7783C225.799 87.9363 228.279 85.875 231.169 85.875H295.446C298.337 85.875 300.817 87.9363 301.345 90.7783L307.256 122.574H219.359L225.27 90.7783Z",
    fill: "#347E8D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M307.255 122.574L301.344 90.7783C300.816 87.9363 298.336 85.875 295.445 85.875H230.281L253.306 122.574H307.255Z",
    fill: "#245F6B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M256.619 84.4425V79.957H258.304C259.333 79.957 259.881 80.5828 259.884 81.4439C259.881 82.302 259.327 82.9246 258.292 82.9246H257.425V84.4425H256.619ZM257.425 82.2617H258.18C258.788 82.2586 259.06 81.9179 259.06 81.4439C259.06 80.9638 258.788 80.6323 258.18 80.6323H257.425V82.2617Z",
    fill: "#CF7E7E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M260.776 84.492C260.51 84.492 260.29 84.2752 260.293 84.0088C260.29 83.7486 260.51 83.5348 260.776 83.5317C261.033 83.5348 261.253 83.7486 261.253 84.0088C261.253 84.2752 261.033 84.492 260.776 84.492Z",
    fill: "#CF7E7E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M262.052 84.4425V79.957H263.738C264.766 79.957 265.314 80.5828 265.317 81.4439C265.314 82.302 264.76 82.9246 263.725 82.9246H262.858V84.4425H262.052ZM262.858 82.2617H263.614C264.221 82.2586 264.493 81.9179 264.493 81.4439C264.493 80.9638 264.221 80.6323 263.614 80.6323H262.858V82.2617Z",
    fill: "#CF7E7E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M266.724 79.957V84.4425H265.931V79.957H266.724Z",
    fill: "#CF7E7E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M268.973 84.5106C267.96 84.5106 267.337 83.8353 267.337 82.7821C267.337 81.7413 267.969 81.035 268.929 81.035C269.753 81.035 270.466 81.5523 270.466 82.7325V82.9804H268.118C268.13 83.5534 268.468 83.8942 268.979 83.8911C269.326 83.8942 269.558 83.7455 269.66 83.5441H270.435C270.292 84.1265 269.753 84.5106 268.973 84.5106ZM268.121 82.4414H269.71C269.707 81.9829 269.397 81.6484 268.942 81.6484C268.468 81.6484 268.149 82.0139 268.121 82.4414Z",
    fill: "#CF7E7E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M228.502 92.8061C228.851 90.9086 230.506 89.5312 232.435 89.5312H294.179C296.109 89.5312 297.763 90.9086 298.113 92.8061L303.601 122.575H223.014L228.502 92.8061Z",
    fill: "#86B7C1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M303.601 122.575L298.113 92.8061C297.764 90.9086 296.109 89.5312 294.18 89.5312H232.561L253.989 122.575H303.601Z",
    fill: "#6C99A3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M219.358 122.574H307.255L314.564 130.035H212.049L219.358 122.574Z",
    fill: "#5CB0C1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M212.049 130.035H314.564V142.115C314.564 147.638 310.087 152.115 304.564 152.115H222.049C216.526 152.115 212.049 147.638 212.049 142.115V130.035Z",
    fill: "#347E8D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M314.564 142.115V130.035H230.736L259.102 152.115H304.564C310.087 152.115 314.564 147.638 314.564 142.115Z",
    fill: "#245F6B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 246.619,
    y: 137.965,
    width: 33.847,
    height: 10.0662,
    fill: "#FFC7C7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M280.466 137.965H246.619V142.439L253.914 148.031H280.466V137.965Z",
    fill: "#9B5050"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 248.24,
    y: 139.543,
    width: 30.6035,
    height: 6.91403,
    fill: "#C76E6E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M278.844 139.543H248.24V143.674L251.98 146.457H278.844V139.543Z",
    fill: "#933838"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_569_27154)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 224.621,
    cy: 143.047,
    r: 4.98458,
    fill: "#FFC7C7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_569_27154)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 301.99,
    cy: 143.047,
    r: 4.98458,
    fill: "#FFC7C7"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M256.619 145.208V140.723H258.304C259.333 140.723 259.881 141.348 259.884 142.21C259.881 143.068 259.327 143.69 258.292 143.69H257.425V145.208H256.619ZM257.425 143.027H258.18C258.788 143.024 259.06 142.683 259.06 142.21C259.06 141.729 258.788 141.398 258.18 141.398H257.425V143.027Z",
    fill: "#842323"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M260.776 145.258C260.51 145.258 260.29 145.041 260.293 144.774C260.29 144.514 260.51 144.3 260.776 144.297C261.033 144.3 261.253 144.514 261.253 144.774C261.253 145.041 261.033 145.258 260.776 145.258Z",
    fill: "#842323"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M262.052 145.208V140.723H263.738C264.766 140.723 265.314 141.348 265.317 142.21C265.314 143.068 264.76 143.69 263.725 143.69H262.858V145.208H262.052ZM262.858 143.027H263.614C264.221 143.024 264.493 142.683 264.493 142.21C264.493 141.729 264.221 141.398 263.614 141.398H262.858V143.027Z",
    fill: "#842323"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M266.724 140.723V145.208H265.931V140.723H266.724Z",
    fill: "#842323"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M268.973 145.276C267.96 145.276 267.337 144.601 267.337 143.548C267.337 142.507 267.969 141.801 268.929 141.801C269.753 141.801 270.466 142.318 270.466 143.498V143.746H268.118C268.13 144.319 268.468 144.66 268.979 144.657C269.326 144.66 269.558 144.511 269.66 144.31H270.435C270.292 144.892 269.753 145.276 268.973 145.276ZM268.121 143.207H269.71C269.707 142.749 269.397 142.414 268.942 142.414C268.468 142.414 268.149 142.78 268.121 143.207Z",
    fill: "#842323"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M305.111 108.479C305.173 107.978 305.599 107.602 306.104 107.602H307.255L306.026 116.436L304.488 113.542L305.111 108.479Z",
    fill: "#245F6B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M305.871 107.602H309.826C311.185 107.602 312.288 108.704 312.288 110.064V110.064C312.288 111.423 311.185 112.525 309.826 112.525H305.871V107.602Z",
    fill: "#245F6B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M305.871 108.445C305.871 108.382 305.921 108.332 305.984 108.332H309.826C310.782 108.332 311.557 109.107 311.557 110.063V110.063C311.557 111.019 310.782 111.794 309.826 111.794H305.984C305.921 111.794 305.871 111.744 305.871 111.681V108.445Z",
    fill: "#6C99A3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M221.502 108.479C221.44 107.978 221.015 107.602 220.51 107.602H219.358L220.587 116.436L222.125 113.542L221.502 108.479Z",
    fill: "#347E8D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M220.742 107.602H216.788C215.428 107.602 214.326 108.704 214.326 110.064V110.064C214.326 111.423 215.428 112.525 216.788 112.525H220.742V107.602Z",
    fill: "#347E8D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M220.742 108.445C220.742 108.382 220.692 108.332 220.63 108.332H216.788C215.832 108.332 215.057 109.107 215.057 110.063V110.063C215.057 111.019 215.832 111.794 216.788 111.794H220.63C220.692 111.794 220.742 111.744 220.742 111.681V108.445Z",
    fill: "#86B7C1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_569_27154",
    x: 219.637,
    y: 138.062,
    width: 10.4688,
    height: 10.4688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.745833 0 0 0 0 0.279687 0 0 0 0 0.279687 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27154"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_569_27154",
    x: 297.006,
    y: 138.062,
    width: 10.4688,
    height: 10.4688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.745833 0 0 0 0 0.279687 0 0 0 0 0.279687 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27154"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport03);
export default __webpack_public_path__ + "static/media/transport_03.d4e1b86583e6c7d9688120692d59b367.svg";
export { ForwardRef as ReactComponent };